const calendarLabel = 'Calendario';
const closeDatePicker = 'Chudi';
const clearDate = 'Pulisci Date';
const jumpToPrevMonth = 'Vai indietro per andare al mese precedente.';
const jumpToNextMonth = 'Vai avanti per andare al mese successivo';
const keyboardShortcuts = 'Scorciatoie da tastiera';
const showKeyboardShortcutsPanel = 'Apri il pannello delle scorciatoie.';
const hideKeyboardShortcutsPanel = 'Close the shortcuts panel.';
const openThisPanel = 'Apri il Pannello.';
const enterKey = 'Clicca un tasto';
const leftArrowRightArrow = 'Frecce Destra e Sinistra';
const upArrowDownArrow = 'Freccia sopra e dotto';
const pageUpPageDown = 'Tasti Pagina successiva e Pagina precedente';
const homeEnd = 'Tasti Inizio e Fine';
const escape = 'Tasto Esc';
const questionMark = 'Punto interrogativo';
const selectFocusedDate = 'Seleziona la data selezionata.';
const moveFocusByOneDay = 'Vai indietro (sinistra) e avanti (destra) di un giorno.';
const moveFocusByOneWeek = 'Vai indietro (sopra) e avanti (sotto) di una settimana.';
const moveFocusByOneMonth = 'Cambia Mese.';
const moveFocustoStartAndEndOfWeek = 'Vai al primo o all\'ultimo giorno della settimana.';
const returnFocusToInput = 'Ritorna alla data inserita.';
const keyboardNavigationInstructions = 'Clicca la freccia giù per interagire con il calendario e selezionare una data. Clicca "?" per vedere le scorciatoie da tastiera.';
const chooseAvailableDate = ({ date }) => date;
const dateIsUnavailable = ({ date }) => `Non disponibile. ${date}`;

export const SingleDatePickerPhrases = {
    calendarLabel,
    closeDatePicker,
    clearDate,
    jumpToPrevMonth,
    jumpToNextMonth,
    keyboardShortcuts,
    showKeyboardShortcutsPanel,
    hideKeyboardShortcutsPanel,
    openThisPanel,
    enterKey,
    leftArrowRightArrow,
    upArrowDownArrow,
    pageUpPageDown,
    homeEnd,
    escape,
    questionMark,
    selectFocusedDate,
    moveFocusByOneDay,
    moveFocusByOneWeek,
    moveFocusByOneMonth,
    moveFocustoStartAndEndOfWeek,
    returnFocusToInput,
    keyboardNavigationInstructions,
    chooseAvailableDate,
    dateIsUnavailable,
  };